import { render, staticRenderFns } from "./eventConfig.vue?vue&type=template&id=2cac6eb0&scoped=true&"
import script from "./eventConfig.vue?vue&type=script&lang=ts&"
export * from "./eventConfig.vue?vue&type=script&lang=ts&"
import style0 from "./eventConfig.vue?vue&type=style&index=0&id=2cac6eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cac6eb0",
  null
  
)

export default component.exports